import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface ResourceDemandCapacityChartProps {
  xAxisData: string[];
  demand: number[];
  capacity?: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function ResourceDemandCapacityChart({
  xAxisData,
  demand,
  capacity,
  height = 260,
  showDataLabels = true,
  density = 'overview',
}: ResourceDemandCapacityChartProps) {
  const series = useMemo(() => {
    const out: { name: string; data: number[] }[] = [{ name: 'Demand', data: demand }];
    if (capacity && capacity.length > 0 && capacity.some((c) => c !== 0)) {
      out.push({ name: 'Capacity', data: capacity });
    }
    return out;
  }, [demand, capacity]);
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
